import { IngredientDocStockDTO, LiquidClassDTO } from 'business/models/Models';
import React, { useEffect, useState } from 'react';
import './MergeStocks.css';
import { MergeStockType } from '../IngredientEnums';
import RMModal from 'components/modal/RMModal';
import RMTable from 'components/customComponents/Controls/RMTable';
import _, { cloneDeep } from 'lodash';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { getLiquidClasses } from 'business/services/IngredientService';
import { MergeStocksButtons, setMergingStocks } from './MergeStockUtils';
import { MergeStockSection } from './MergeStockSection';
import { MergeStocksTable, columns } from '../IngredientConstants';
import { useRMDispatch } from 'redux/hooks';
import { useIngredientsDataIndicator } from 'redux/hooks/ingredients';
import { MergeStockProps } from '../mergeIngredients/MergeIngredientConstants';
import { FmlxModal } from 'fmlx-common-ui';

export const MergeStocks = (props: MergeStockProps) => {
  const {
    showModal,
    setShowModal,
    setStocksShowModal,
    matchedStocks,
    ingredients,
    stockOne,
    stockTwo,
    setStocks,
    onClickMergeStock,
    mergeIngredient,
    matchedIngStocks,
    setMergeIngredient,
    setMatchedStocks,
    setStockIndex,
    stockIndex,
    setIsMerging,
  } = props;
  const [tempStock, setTempStock] = useState<IngredientDocStockDTO>();
  const [mergeStock, setMergeStock] = useState<IngredientDocStockDTO>(
    new IngredientDocStockDTO(),
  );
  const [excludedStockIds, setExcludedStockIds] = useState<number[]>([]);
  const [mergeStockType, setMergeStockType] = useState<MergeStockType>(
    MergeStockType.Stock1,
  );
  const [liquidClasses, setLiquidClasses] = useState<LiquidClassDTO[]>();
  const [stocksTable, setStocksTable] = useState<MergeStocksTable[]>([]);
  const [selectedRows, setSelectedRows] = useState<number[]>([0]);
  const dispatch = useRMDispatch();
  const ingTableDataIndicator = useIngredientsDataIndicator();
  useEffect(() => {
    if (showModal) {
      if (!stockOne || !stockTwo) {
        setStockIndex(stockIndex + 1);
        setStocksShowModal(false);
        return;
      }
      if (
        stockOne?.stockConcentration !== stockTwo?.stockConcentration ||
        stockOne?.stockPh !== stockTwo?.stockPh ||
        stockOne?.concentrationUnits !== stockTwo?.concentrationUnits
      ) {
        setStocksShowModal(false);
        showAlertSnackBar(
          EAlertType.ERROR,
          ESnackBarPosition.TOP,
          'Stocks must have the same concentration, concentration unit, and pH.',
        );
        return;
      }
      const getAllLiquidClasses = async () => {
        const liqClasses = await getLiquidClasses();
        setLiquidClasses(liqClasses);
      };
      getAllLiquidClasses();
      resetMergeStock();
      setTempStock(new IngredientDocStockDTO());
      setSelectedRows([0]);
    }
  }, [showModal, stockTwo]);

  useEffect(() => {
    const tableData = matchedStocks?.map((stock) => {
      const entry = {
        ingredientName: ingredients.find((ing) => ing.id === stock.ingredientId)
          ?.longName,
        stockConc: stock.stockConcentration,
        concUnits: stock.concentrationUnits,
        pH: stock.stockPh,
        lowConc: stock.lowConcentration,
        highConc: stock.highConcentration,
        vendor: stock.vendor?.name,
        vendorPart: stock.vendorPartNumber,
      } as MergeStocksTable;
      return entry;
    });
    if (tableData) {
      setStocksTable(tableData);
    }
  }, [matchedStocks, showModal]);

  const resetMergeStock = () => {
    if (!stockOne) {
      return;
    }
    const tempMergeStock = new IngredientDocStockDTO();
    tempMergeStock.stockConcentration = stockOne.stockConcentration;
    tempMergeStock.concentrationUnits = stockOne.concentrationUnits;
    tempMergeStock.stockPh = stockOne.stockPh;
    tempMergeStock.isPrepared = stockOne.isPrepared;
    tempMergeStock.comments = stockOne.comments;
    setMergeStock(tempMergeStock);
  };

  const addMergeStock = (ingStock: IngredientDocStockDTO, property: string) => {
    const stock = mergeStock;
    const tempStock = new IngredientDocStockDTO();
    if (Array.isArray(stock[property])) {
      ingStock[property]?.map((item) => {
        if (!stock[property].some((innerItem) => _.isEqual(innerItem, item))) {
          stock[property].push(item);
        }
      });
    } else {
      stock[property] = ingStock[property];
    }
    setMergeStock(cloneDeep(stock));
    setTempStock(cloneDeep(tempStock));
  };

  const onClickButton = (value: MergeStockType) => {
    value === MergeStockType.Stock1
      ? setMergeStock(cloneDeep(stockOne))
      : value === MergeStockType.Stock2
      ? setMergeStock(cloneDeep(stockTwo))
      : resetMergeStock();
  };
  const handleSelectionChange = (row) => {
    if (row) {
      setSelectedRows([row.index]);
      if (setStocks) {
        setStocks([matchedStocks[row.index], stockTwo]);
      }
    }
  };
  const commandButtonsList = (
    <MergeStocksButtons
      mergeStock={mergeStock}
      setShowModal={setShowModal}
      onClickMergeStock={onClickMergeStock}
      excludedId={stockOne?.id !== mergeStock?.id ? stockOne?.id : stockTwo?.id}
      mergeIngredient={mergeIngredient}
      matchedIngStocks={matchedIngStocks}
      setMergeIngredient={setMergeIngredient}
      setMergingStocks={setMergingStocks}
      setStocks={setStocks}
      ingredients={ingredients}
      setMatchedStocks={setMatchedStocks}
      setStockIndex={setStockIndex}
      dispatch={dispatch}
      ingTableDataIndicator={ingTableDataIndicator}
      stockIndex={stockIndex}
      setStocksShowModal={setStocksShowModal}
      excludedStockIds={excludedStockIds}
      setExcludedStockIds={setExcludedStockIds}
      setIsMerging={setIsMerging}
    />
  );
  const matchedStocksTable = matchedStocks ? (
    <div id="mergestock-matchstockstable-wrapper" className="merge-stocks-table">
      <h6 id="mergestock-matchstockstable-header">Ingredient Stocks</h6>
      <p id="mergestock-matchstockstable-message">
        Following Stock of this ingredient is appear to be similar to stock being merged.
      </p>
      <div id="mergestock-matchstockstable-table">
        <RMTable
          columns={columns}
          data={stocksTable}
          onRowClicked={handleSelectionChange}
          selectedIds={selectedRows}
          selectRowOnClick={false}
          mainContainerStyle={{ maxHeight: '100px' }}
        />
      </div>
    </div>
  ) : (
    <></>
  );

  const mergeStockContainer =
    showModal === false ? (
      <></>
    ) : (
      <RMModal
        id="mergestock-matchstockscontainer-wrapper"
        showModal={showModal}
        setShowModal={setStocksShowModal}
        body={
          <div id="mergestock-matchstockscontainer-body">
            {matchedStocksTable}
            <p id="mergestock-matchstockscontainer-message">
              You may choose individual fields from both stocks to compose the resulting
              stock and save it as the merged stocks.
            </p>

            <div
              id="mergestock-matchstockscontainer-sections"
              className="flex flex-direction-row"
            >
              <div
                id="mergestock-matchstockscontainer-stock1-wrapper"
                className="border-box merge-ingredient-container w-1/3"
              >
                <div id="mergestock-matchstockscontainer-stock1-section">
                  <MergeStockSection
                    heading="Stock 1"
                    buttonText="Copy All"
                    mergeStockType={mergeStockType}
                    stock={stockOne}
                    onClickAdd={addMergeStock}
                    onClickButton={onClickButton}
                    setTempStock={setTempStock}
                    tempStock={tempStock}
                    setCurrentMergeStockType={setMergeStockType}
                    currentMergeStockType={MergeStockType.Stock1}
                    showButtons={false}
                    liquidClasses={liquidClasses}
                  />
                </div>
              </div>
              <div
                id="mergestock-matchstockscontainer-stock2-wrapper"
                className="border-box merge-ingredient-container w-1/3"
              >
                <div id="mergestock-matchstockscontainer-stock2-section">
                  <MergeStockSection
                    heading="Stock 2"
                    buttonText="Copy All"
                    mergeStockType={mergeStockType}
                    stock={stockTwo}
                    onClickAdd={addMergeStock}
                    onClickButton={onClickButton}
                    setTempStock={setTempStock}
                    tempStock={tempStock}
                    setCurrentMergeStockType={setMergeStockType}
                    currentMergeStockType={MergeStockType.Stock2}
                    showButtons={false}
                    liquidClasses={liquidClasses}
                  />
                </div>
              </div>
              <div
                id="mergestock-matchstockscontainer-merged-wrapper"
                className="border-box merge-ingredient-container w-1/3"
              >
                <div id="mergestock-matchstockscontainer-merged-wrapper">
                  <MergeStockSection
                    heading="Merge Stock"
                    buttonText="Clear All"
                    mergeStockType={mergeStockType}
                    stock={mergeStock}
                    onClickAdd={addMergeStock}
                    onClickDelete={setMergeStock}
                    onClickButton={onClickButton}
                    setTempStock={setTempStock}
                    tempStock={tempStock}
                    setCurrentMergeStockType={setMergeStockType}
                    currentMergeStockType={MergeStockType.MergeStock}
                    showButtons={true}
                    liquidClasses={liquidClasses}
                  />
                </div>
              </div>
            </div>
            <div
              id="mergestock-matchstockscontainer-commandbuttons"
              className="p-1 float-right cursor-pointer"
            >
              {commandButtonsList}
            </div>
          </div>
        }
        heading="Merge Ingredient Stocks"
        showButtons={false}
        dialogClassName="stocks-merge-modal"
        size={FmlxModal.Size.EXTRA_LARGE}
      />
    );
  return <>{mergeStockContainer}</>;
};
